import { Typography } from '@mui/material';
import styled from 'styled-components';

export const TruncatedTypography = styled(Typography)`
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
